import TimeLeft from "components/General/TimeLeft";
import { HIGHLIGHTS } from "utils/ToolTipConst";
import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom"
import InfoPopout from "components/Wrappers/InfoPopout";

export default function Timer({
  time = 0,
}: { time: number }) { // time is in seconds
  return (
    <div className="h-full w-full border-2 border-black bg-[#BCB7A8] flex items-center justify-center">
      <TimeLeft time={time}/>

      <InfoPopout
        maxWidth={400}
        popupContent={
          <div className="text-sm">
            <p>Time until <span className={HIGHLIGHTS.neutral}> Townhall</span>, where players will vote for the <span className={HIGHLIGHTS.neutral}> water management regime</span>, and the year will advance.</p>

          </div>} />
    </div>

  )
}
